export const PRODUCTS = [
			  {
			    id: 1,
			    name: 'Yamaha R1',
			    quantity: {
			      qteTotal: 3,
			      stocksParDepot: [
			        { nomDepot: 'Central', qteEnStock: 2 },
			        { nomDepot: 'Annexe A', qteEnStock: 1 }
			      ]
			    },
			    entryPrice: 12000,
			    salePrice: 15000,
			    prices: { gros: 15000, demiGros: 15500, detail: 17000 },
			    category: 'Motos',
			    description: 'Moto de course haute performance.',
			    audioUrl: 'assets/audio/yamaha.mp3',
			    imageUrl: 'https://www.motoplanete.com/yamaha/zoom-700px/Yamaha-1000-YZF-R1-2021-700px.webp',
			    stockIn: 0,
			    stockOut: 0
			  },
			  {
			    id: 2,
			    name: 'KTM EXC 250',
			    quantity: {
			      qteTotal: 5,
			      stocksParDepot: [
			        { nomDepot: 'Central', qteEnStock: 3 },
			        { nomDepot: 'Magasin B', qteEnStock: 2 }
			      ]
			    },
			    entryPrice: 8000,
			    salePrice: 9500,
			    prices: { gros: 9000, demiGros: 9200, detail: 9500 },
			    category: 'Motos',
			    description: 'Moto enduro légère et performante.',
			    audioUrl: '',
			    imageUrl: '',
			    stockIn: 0,
			    stockOut: 0
			  },
			  {
			    id: 3,
			    name: 'Kit chaîne renforcé',
			    quantity: {
			      qteTotal: 20,
			      stocksParDepot: [
			        { nomDepot: 'Central', qteEnStock: 12 },
			        { nomDepot: 'Magasin B', qteEnStock: 8 }
			      ]
			    },
			    entryPrice: 50,
			    salePrice: 80,
			    prices: { gros: 45, demiGros: 48, detail: 55 },
			    category: 'Pièces détachées',
			    description: 'Kit chaîne haute résistance pour long usage.',
			    audioUrl: '',
			    imageUrl: '',
			    stockIn: 0,
			    stockOut: 0
			  },
			  {
			    id: 4,
			    name: 'Batterie moto lithium',
			    quantity: {
			      qteTotal: 15,
			      stocksParDepot: [
			        { nomDepot: 'Central', qteEnStock: 10 },
			        { nomDepot: 'Dépôt Sud', qteEnStock: 5 }
			      ]
			    },
			    entryPrice: 100,
			    salePrice: 150,
			    prices: { gros: 95, demiGros: 110, detail: 150 },
			    category: 'Pièces détachées',
			    description: 'Batterie performante avec longue durée de vie.',
			    audioUrl: 'assets/audio/batterie.mp3',
			    imageUrl: '',
			    stockIn: 0,
			    stockOut: 0
			  },
			  {
			    id: 5,
			    name: 'Plaquettes de frein Brembo',
			    quantity: {
			      qteTotal: 30,
			      stocksParDepot: [
			        { nomDepot: 'Central', qteEnStock: 25 },
			        { nomDepot: 'Magasin B', qteEnStock: 5 }
			      ]
			    },
			    entryPrice: 40,
			    salePrice: 70,
			    prices: { gros: 35, demiGros: 45, detail: 70 },
			    category: 'Pièces détachées',
			    description: '',
			    audioUrl: '',
			    imageUrl: '',
			    stockIn: 0,
			    stockOut: 0
			  },
			  {
			    id: 6,
			    name: 'Casque intégral Shoei',
			    quantity: {
			      qteTotal: 10,
			      stocksParDepot: [
			        { nomDepot: 'Central', qteEnStock: 5 },
			        { nomDepot: 'Boutique Moto', qteEnStock: 5 }
			      ]
			    },
			    entryPrice: 300,
			    salePrice: 450,
			    prices: { gros: 350, demiGros: 375, detail: 450 },
			    category: 'Accessoires',
			    description: 'Casque intégral premium avec visière solaire.',
			    audioUrl: 'assets/audio/shoei.mp3',
			    imageUrl: 'assets/images/shoei.jpg',
			    stockIn: 0,
			    stockOut: 0
			  },
			  {
			    id: 7,
			    name: 'Gants moto cuir homologués',
			    quantity: {
			      qteTotal: 25,
			      stocksParDepot: [
			        { nomDepot: 'Central', qteEnStock: 15 },
			        { nomDepot: 'Annexe A', qteEnStock: 10 }
			      ]
			    },
			    entryPrice: 50,
			    salePrice: 80,
			    prices: { gros: 60, demiGros: 65, detail: 80 },
			    category: 'Accessoires',
			    description: '',
			    audioUrl: '',
			    imageUrl: '',
			    stockIn: 0,
			    stockOut: 0
			  },
			  {
			    id: 8,
			    name: 'Antivol U homologué',
			    quantity: {
			      qteTotal: 20,
			      stocksParDepot: [
			        { nomDepot: 'Central', qteEnStock: 10 },
			        { nomDepot: 'Boutique Moto', qteEnStock: 10 }
			      ]
			    },
			    entryPrice: 60,
			    salePrice: 100,
			    prices: { gros: 85, demiGros: 90, detail: 100 },
			    category: 'Accessoires',
			    description: 'Antivol solide et certifié SRA.',
			    audioUrl: '',
			    imageUrl: '',
			    stockIn: 0,
			    stockOut: 0
			  },
			  {
			    id: 9,
			    name: 'Gilet fluo de sécurité',
			    quantity: {
			      qteTotal: 50,
			      stocksParDepot: [
			        { nomDepot: 'Central', qteEnStock: 25 },
			        { nomDepot: 'Annexe A', qteEnStock: 25 }
			      ]
			    },
			    entryPrice: 10,
			    salePrice: 20,
			    prices: { gros: 9, demiGros: 10, detail: 20 },
			    category: 'Accessoires',
			    description: 'Indispensable pour la conduite de nuit.',
			    audioUrl: '',
			    imageUrl: '',
			    stockIn: 0,
			    stockOut: 0
			  },
			  {
			    id: 10,
			    name: 'Chargeur USB étanche',
			    quantity: {
			      qteTotal: 40,
			      stocksParDepot: [
			        { nomDepot: 'Central', qteEnStock: 30 },
			        { nomDepot: 'Magasin B', qteEnStock: 10 }
			      ]
			    },
			    entryPrice: 25,
			    salePrice: 40,
			    prices: { gros: 22, demiGros: 25, detail: 40 },
			    category: 'Accessoires',
			    description: 'Chargeur double USB pour guidon de moto.',
			    audioUrl: '',
			    imageUrl: 'assets/images/usb-charger.jpg',
			    stockIn: 0,
			    stockOut: 0
			  }
			];

